import React from "react";

// Palette + a fixed "scramble" so each tile shows a different colour.
const CUBE_PALETTE = [
  "#c14f73",
  "#9b3d58",
  "#a53d5d",
  "#d66486",
  "#9fcfc0",
  "#7fdcc0",
  "#56c596",
  "#c97c93",
];
const SCRAMBLE = [
  [0, 2, 5, 3, 1, 7, 6, 4, 2], // top
  [1, 4, 0, 7, 3, 5, 2, 6, 0], // left
  [3, 0, 6, 2, 5, 1, 4, 7, 3], // right
];

// Isometric, scrambled 3x3 cube. Sizes to 1em via currentColor-independent fills.
const RubiksCube = () => {
  const faces = [
    { O: [12, 1.5], U: [10.5, 5.5], V: [-10.5, 5.5], depth: 1 }, // top
    { O: [1.5, 7], U: [10.5, 5.5], V: [0, 9.5], depth: 0.72 }, // left
    { O: [12, 12.5], U: [10.5, -5.5], V: [0, 9.5], depth: 0.5 }, // right
  ];
  const pt = (f, s, t) => [
    +(f.O[0] + s * f.U[0] + t * f.V[0]).toFixed(2),
    +(f.O[1] + s * f.U[1] + t * f.V[1]).toFixed(2),
  ];
  const tiles = [];
  const lines = [];
  faces.forEach((f, fi) => {
    for (let i = 0; i < 3; i++) {
      for (let j = 0; j < 3; j++) {
        const a = pt(f, i / 3, j / 3);
        const b = pt(f, (i + 1) / 3, j / 3);
        const c = pt(f, (i + 1) / 3, (j + 1) / 3);
        const d = pt(f, i / 3, (j + 1) / 3);
        tiles.push(
          <path
            key={`t${fi}-${i}-${j}`}
            d={`M${a} L${b} L${c} L${d} Z`}
            fill={CUBE_PALETTE[SCRAMBLE[fi][i * 3 + j]]}
            fillOpacity={f.depth}
            stroke="none"
          />
        );
      }
    }
    const c0 = pt(f, 0, 0);
    const c1 = pt(f, 1, 0);
    const c2 = pt(f, 1, 1);
    const c3 = pt(f, 0, 1);
    lines.push(
      <path key={`o${fi}`} d={`M${c0} L${c1} L${c2} L${c3} Z`} fill="none" />
    );
    for (let k = 1; k < 3; k++) {
      const a = pt(f, k / 3, 0);
      const b = pt(f, k / 3, 1);
      lines.push(
        <line key={`s${fi}${k}`} x1={a[0]} y1={a[1]} x2={b[0]} y2={b[1]} />
      );
      const c = pt(f, 0, k / 3);
      const d = pt(f, 1, k / 3);
      lines.push(
        <line key={`l${fi}${k}`} x1={c[0]} y1={c[1]} x2={d[0]} y2={d[1]} />
      );
    }
  });
  return (
    <svg viewBox="0 0 24 24" width="1em" height="1em" aria-hidden="true">
      {tiles}
      <g
        stroke="#111316"
        strokeWidth="0.7"
        strokeLinejoin="round"
        strokeLinecap="round"
      >
        {lines}
      </g>
    </svg>
  );
};

export default RubiksCube;
